import { AdminPageHeader } from '@/components/patterns/admin-page'
import MessageForm from '@/components/forms/MessageForm'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { MessageCirclePlus } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/$orgId/messages/create')({
  beforeLoad: ({ context }) => {
    if (!context.ability.can('create', 'messages')) throw notFound()
  },
  loader: () => ({ isReadOnly: false }),
  component: RouteComponent,
})

export function RouteComponent() {
  return (
    <div className="max-w-4xl space-y-6">
      <AdminPageHeader
        icon={MessageCirclePlus}
        title="Create Customer Inquiry"
        description="Log an inquiry your shop received in person, by phone, or by email. Saving this form creates an internal record only; it does not send a message, email, or text to the customer."
      />
      <MessageForm />
    </div>
  )
}
